module.exports = __webpack_public_path__ + "static/media/ohutusvest_kiiver.65c20604.svg";